export const validateSubdomain = (subdomain = "") => {
  return /^[a-z0-9]+$/.test(subdomain);
};
